export const assertContentType = (data: any, contentType: string): void => {
  if (data?.sys?.contentType?.sys.id !== contentType) {
    throw new Error(`Expected contentType to be '${contentType}'. Found '${data?.sys?.contentType?.sys.id}'`);
  }
};
